// styles
import styles from "./Contact.module.css"
const ConfirmSend = () => {
   
    return (
        <>
            <div>
                <h2>Email has been sent to support staff.</h2>
                <br /><br /><br />
                <h3>The intent of this form is to handle issues and questions related to Event Sync. Questions outside of this scope may not be reviewed.<br /><br />
                    Once review of the form details is complete, someone will reach out to you in a timely manner. We apologize for any inconvenience.</h3>
            </div>
        </>

      
    );
}
export default ConfirmSend;